import React from 'react'
import { Link } from 'react-router-dom'
import registerImage from '../assets/images/LoginSignup.jpg'

export default function Register() {
  return (
    <div className="min-vh-100 bg-white">
      <div className="container-fluid px-0">
        <div className="row g-0 min-vh-100 align-items-stretch shadow-lg rounded-4 overflow-hidden">
          {/* LEFT PANEL */}
          <div
            className="col-12 col-lg-6 position-relative d-flex flex-column justify-content-center text-white p-5"
            style={{
              backgroundImage: `url(${registerImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0,0,0,0.6)' }} />

            <div className="position-relative">
              <h1 className="fw-bold display-4 mb-4 ">Lucentum Basketball Universe</h1>
              <ul className="fs-6 ps-3" style={{ listStyle: 'disc' }}>
                <li className="mb-2">Immerse yourself in the world of Lucentum Basketball</li>
                <li className="mb-2">Get exclusive access to match tickets, stats, and insights</li>
                <li className="mb-2">Engage with top players and team mentors</li>
                <li className="mb-2">Collaborate with fans, sponsors, and teammates</li>
                <li className="mb-2">Unlock rewards with every game and event</li>
              </ul>
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="col-12 col-lg-6 bg-white d-flex align-items-center justify-content-center">
            <form className="w-100 px-0" style={{ maxWidth: 440, fontFamily: 'Poppins, sans-serif' }}>
              <h2 className="text-center fw-semibold mb-4" style={{ fontSize: '22px' }}>Register</h2>

              <div className="vstack gap-3">
                <input type="text" className="form-control p-2 rounded-2 border-dark-subtle" placeholder="John" required style={{ fontSize: '15px' }} />
                <input type="text" className="form-control p-2 rounded-2 border-dark-subtle" placeholder="Doe" required style={{ fontSize: '15px' }} />
                <input type="email" className="form-control p-2 rounded-2 border-dark-subtle" placeholder="johndoe@gmail.com" required style={{ fontSize: '15px' }} />
                <input type="password" className="form-control p-2 rounded-2 border-dark-subtle" placeholder="Password" required style={{ fontSize: '15px' }} />
                <input type="password" className="form-control p-2 rounded-2 border-dark-subtle" placeholder="Confirm Password" required style={{ fontSize: '15px' }} />
              </div>

              <div className="mt-3" style={{ fontSize: '14px' }}>
                <div className="form-check mb-2">
                  <input className="form-check-input" type="checkbox" id="cb1" defaultChecked required />
                  <label className="form-check-label text-capitalize" htmlFor="cb1">
                    I have read and agree to lucentum
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input className="form-check-input" type="checkbox" id="cb2" defaultChecked required />
                  <label className="form-check-label text-capitalize" htmlFor="cb2">
                    I have read and agree  to terms of use
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="cb3" defaultChecked required />
                  <label className="form-check-label text-capitalize" htmlFor="cb3">
                    I have read and agree  Privacy Policy
                  </label>
                </div>
              </div>

              <button
                type="submit"
                className="btn w-100 py-2 mt-3 fw-semibold"
                style={{ backgroundColor: '#0440A8', color: '#fff', fontSize: '15px', borderRadius: '6px' }}
              >
                Register
              </button>

              <p className="text-center mt-3 mb-0" style={{ fontSize: '14px' }}>
                Already a Member <Link to="/login" className="text-decoration-none fw-semibold text-dark">Login</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}